// import isEmpty  from 'lodash/isEmpty';
import {prtStart, prtVar} from '../utils/prt'
let trace = true;
let compName = 'event.js';


const initialState = {
    event: { },
}

export default (state = initialState, action = {}) => {
    trace && prtStart(compName, 'event reducer')
    trace && prtVar('action', JSON.stringify(action,null,2))
    
    // when user logs in, we set uid on the state object.
    switch (action.type) {
        case 'UPDATE_ALL_EVENT_METRICS':
            //trace && prtMsg("Inside Case Statement for UPDATE_ALL_EVENT_METRICS for event reducer")
            //trace && prtInput('action.activeEvent', action);
            return Object.assign({}, state, {        
                metrics: action.metrics
            })
        case 'CLEAR_ALL_EVENT_METRICS':
            //trace && prtMsg("Inside Case Statement for CLEAR_ALL_EVENT_METRICS for event reducer")
            //trace && prtInput('action.activeEvent', action);
            return Object.assign({}, state, {        
                metrics: action.metrics
            })
        case 'SAVE_EVENT_INFO':
            // trace && prtObjVar('action.activeEvent', action.selected);
            return {
                active: action.active
            }
        case 'CLEAR_ACTIVE_EVENT':  /* clear pic application state */
            return {
                active: {}
            }
        case 'SET_ACTIVE_EVENT':  /* clear pic application state */
            return {
                active: action.event
            }
        case 'SHOW_SUCCESS_MESSAGE':  // this action shows/hides success message 
            return Object.assign({}, state, {        //   when saving event info
                showSuccessMessage: action.showSuccessMessage
            })
        case 'INITIALIZE_EVENT_LIST':  /* called when sendInvites component mounts */
            return Object.assign({}, state, {
                list: action.list
            })
        case 'UPDATE_EVENT_LIST':  
            return Object.assign({}, state, {
                list: action.list
            })
        case 'UPDATE_EVENTS_INVITED_TO_LIST':  /* Called when user selects "Events Invited To" on Dashboard to update list on redux store */
            return Object.assign({}, state, {
                invitedToList: action.invitedToList
            })
        default:
            return state;
    }
};






// WEBPACK FOOTER //
// ./src/reducers/event.js